"use client";
import React, { useEffect } from "react";
import { useParams } from "next/navigation";
import dynamic from "next/dynamic";
import ListSection from "./ListSection";
import useAppDispatch from "@/app/hooks/useAppDispatch";
import { useSelector } from "react-redux";
import { fetchFaqs, fetchFaqSections } from "@/store/faqSlice";
import ProgressBar from "@/components/ProgressBar";

// Dynamically import VerticalNavBar with SSR disabled for client-side rendering
const VerticalNavBar = dynamic(
  () => import("@/components/Common/VerticalNavBar"),
  { ssr: false }
);
const BASE_PATH = "/help/faq/";
export default function FAQSectionPage() {
  const params = useParams();
  const sectionName = params?.section as string;
  const faqSections = useSelector((state: any) => state.faq.sectionsInfo);
  const faqData = useSelector((state: any) => state.faq.faqListInfo);
  const loading = useSelector(
    (state: any) => state.faq.faqSectionsLoading || state.faq.faqsLoading
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    // Fetch FAQ data when the component mounts
    dispatch(fetchFaqs(sectionName));
    dispatch(fetchFaqSections());
  }, [dispatch, sectionName]);

  return (
    <div>
      <div className="absolute top-0 left-0 right-0 z-[1000]">
        <ProgressBar loading={loading} />
      </div>
      <VerticalNavBar
        options={faqSections.data.map((section: any) => ({
          value: section.header,
          to: section.name,
        }))}
        currentPath={sectionName}
        basePath={BASE_PATH}
      >
        {!loading ? (
          <ListSection
            list={
              faqData?.data
                ? [...faqData.data].sort((a, b) => {
                    const priorityA =
                      a.priority !== undefined
                        ? a.priority
                        : Number.MAX_SAFE_INTEGER;
                    const priorityB =
                      b.priority !== undefined
                        ? b.priority
                        : Number.MAX_SAFE_INTEGER;
                    return priorityA - priorityB;
                  })
                : []
            }
          />
        ) : null}
      </VerticalNavBar>
    </div>
  );
}
